import type { BackofficeNavItem } from "./backofficeNav.types";
import { MODERATOR_ROUTES, ROUTES } from "./routes";

export const MODERATOR_NAV_ITEMS: readonly BackofficeNavItem[] = [
  { to: ROUTES.backoffice.moderar, label: "Inicio", end: true },
  {
    to: `/${MODERATOR_ROUTES.root}/${MODERATOR_ROUTES.castings}`,
    label: "Castings",
    permission: "castings:manage",
  },
];
